export default "__VITE_ASSET__Sj$DGxfK__"